interface DeliveryDay {
    label: string;
    date: string;
} // ISO YYYY-MM-DD

export function getDeliveryDays(baseDate?: Date): DeliveryDay[] {
    const days: DeliveryDay[] = [];
    const now = baseDate ? new Date(baseDate) : new Date();

    // --- utils ---
    const cloneDate = (d: Date) => new Date(d.getTime());
    const addDays = (d: Date, n: number) => {
        const c = cloneDate(d);
        c.setDate(c.getDate() + n);
        return c;
    };
    const normalizeToDay = (d: Date) => {
        const c = cloneDate(d);
        c.setHours(0, 0, 0, 0);
        return c;
    };

    const monthNames: string[] = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const holidays = new Set<string>([
        "01-01", // New Year's Day (Новый год)
        "03-21", // Human Rights Day (День прав человека)
        "04-27", // Freedom Day (День свободы)
        "05-01", // Workers' Day (День трудящихся)
        "06-16", // Youth Day (День молодежи)
        "08-09", // National Women's Day (Национальный день женщин)
        "09-24", // Heritage Day (День наследия)
        "12-16", // Day of Reconciliation (День примирения)
        "12-25", // Christmas Day (Рождество)
        "12-26", // Day of Goodwill (День доброй воли)
        // --- TEMP: временные выходные, удалить после 09.10 ---
        "09-29",
        "09-30",
        "10-01",
        "10-02",
        "10-03",
        "10-04",
        "10-05",
        "10-06",
        "10-07",
        "10-08",
        // --- END TEMP ---
    ]);

    const mmdd = (d: Date) =>
        `${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    const isHoliday = (d: Date): boolean => {
        if (holidays.has(mmdd(d))) {
            return true;
        }

        // Правило воскресенья: если сегодня понедельник
        if (d.getDay() === 1) {
            const yesterday = new Date(d.getTime());
            yesterday.setDate(yesterday.getDate() - 1);

            // Если вчерашнее воскресенье было государственным праздником, то сегодня тоже выходной
            if (holidays.has(mmdd(yesterday))) {
                return true;
            }
        }

        return false;
    };
    const isWeekend = (d: Date) => {
        const day = d.getDay();
        return day === 0 || day === 6;
    };

    const isWorkday = (d: Date) => !isWeekend(d) && !isHoliday(d);

    const getNextWorkday = (from: Date) => {
        let d = addDays(from, 1);

        d = normalizeToDay(d);
        while (!isWorkday(d)) {
            d = addDays(d, 1);
        }
        return d;
    };

    const nowNormalized = cloneDate(now);
    const hour = nowNormalized.getHours();

    let startDate: Date;

    if (isWorkday(now)) {
        if (hour < 12) {
            startDate = getNextWorkday(now);
        } else {
            const tomorrow = addDays(now, 1);

            const firstWorkday = getNextWorkday(now);

            if (isWorkday(tomorrow)) {
                startDate = getNextWorkday(firstWorkday);
            } else {
                startDate = firstWorkday;
            }
        }
    } else {
        startDate = getNextWorkday(now);
    }

    let cursor = normalizeToDay(startDate);
    while (days.length < 5) {
        if (isWorkday(cursor)) {
            const day = cursor.getDate();
            const month = monthNames[cursor.getMonth()];
            const year = cursor.getFullYear();
            const iso = `${year}-${String(cursor.getMonth() + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            days.push({ label: `${day} ${month}`, date: iso });
        }
        cursor = addDays(cursor, 1);
    }

    return days;
}
